import {useCallback} from 'react';

import {useCommonEventHook} from 'src/hooks/use-common-event-hook';
import {deleteSection} from 'src/openapi/admin/apis/ConferenceSectionsApi';
import {useAppDispatch} from 'src/store/hooks';

type Props = {
    onSuccess: () => void,
};

export const useRemoveSection = ({onSuccess}: Props) => {
    const apiDispatch = useAppDispatch();

    const eventAction = useCallback((sectionId: number) => apiDispatch(
        deleteSection({sectionId}),
    ), [apiDispatch]);

    return useCommonEventHook({
        eventAction,
        onSuccess,
    });
};
